import styled from 'styled-components';
export const Wrapper = styled.span `
    text-transform: lowercase;
`;
//# sourceMappingURL=Price.styles.js.map